import {Grid} from '@mui/material'
import {React, styled} from 'common'
import FormField from '../FormField'
import {Texts} from 'appearance'
import {FormProvider} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import FormArray from './FormArray'
import {useEffect} from 'react'
const FormSection = ({fields, i18nCategory, methods}) => {
    const {t} = useTranslation()
    const {
        setFocus,
        formState: {errors},
    } = methods

    useEffect(() => {
        const firstErrorField = Object.keys(errors)[0]
        if (firstErrorField) {
            setFocus(firstErrorField)
        }
    }, [errors, setFocus])
    return (
        <FormProvider {...methods}>
            <Container>
                {Object.entries(fields).map(([key, field]) => {
                    if (field?.hidden) return null
                    return (
                        <FormContainer key={`form_container_${key}`}>
                            {field.title && <Title>{t(`${i18nCategory}.${field.title}`)}</Title>}

                            {field?.type === 'array' ? (
                                <FormArray
                                    arrayName={field.arrayName}
                                    withButtons={field.withButtons}
                                    appendOnEmpty={field.appendOnEmpty}
                                    fieldsComponent={field.items}
                                />
                            ) : (
                                <GridContainer container spacing={2}>
                                    {Object.values(field?.items || {}).map((item, key) => (
                                        <Grid
                                            key={`form_grid_container_${key}`}
                                            item
                                            xs={item?.xs}
                                            sm={item?.sm}>
                                            <FormField field={item} i18n={i18nCategory} />
                                        </Grid>
                                    ))}
                                </GridContainer>
                            )}
                        </FormContainer>
                    )
                })}
            </Container>
        </FormProvider>
    )
}

export default FormSection

const GridContainer = styled(Grid)``

const Title = styled(Texts.Title)``

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`
